export enum ProjectType {
  ProjectWorkplaceSituation = 'project-workplace-situation',
  ProfessionalSupportNetwork = 'professional-support-network',
  SupportSituation = 'support-situation',
  ReflectivePracticeAnalysisSituation = 'reflective-practice-analysis-situation',
  Other = 'other',
}
